import { ArrowRightIcon, FetchingErrorIcon } from 'assets/icons';
import { Component, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import routesPath from 'routes/RoutesPath';
import * as Sentry from '@sentry/react';

interface ErrorBoundaryProps {
  children: ReactElement;
}

interface ErrorBoundaryState {
  hasError: boolean;
  eventId: string | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const eventId = Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo.componentStack
        }
      }
    });
    this.setState({ eventId });
  }

  handleGoBack = () => {
    this.setState({ hasError: false, eventId: null });
  };

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <div className="flex h-full w-full items-center justify-center">
          <div className="flex flex-col items-center justify-center gap-2">
            <FetchingErrorIcon />
            <div className="text-xl text-accentText">Something went wrong!</div>
            <Link to={routesPath.HOME}>
              <div className="flex cursor-pointer items-center gap-2" onClick={this.handleGoBack} role="presentation">
                <div className="rotate-180">
                  <ArrowRightIcon />
                </div>
                <div className="text-lg text-accentText">Go back to Home</div>
              </div>
            </Link>
          </div>
        </div>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
